import { StringField } from "../../../types/types";
import {
  IconButtonFields,
  IconButtonProps,
  IconButton,
} from "../types/IconButton.types";

export class IconButtonModel {
  private readonly fields?: IconButtonFields;

  constructor(props: IconButtonProps) {
    this.fields = props.fields;
  }

  get title(): StringField | undefined {
    return this.fields?.Title
  }

  get icon(): StringField | undefined {
    return this.fields?.Icon
  }

  get label(): StringField | undefined {
    return this.fields?.Label
  }
  
  get downloadLink() {
    return this.fields?.Link
  }
}
